import { NgModule } from "@angular/core";
import { TextShortenerPipe } from "./text-shortener.pipe";
import { FileSizeConverterPipe } from "./size-calculator.pipe";
import { ignoreHtmlSanifications } from "./ignore-html-sanifications.pipe";

@NgModule({
  imports: [
    // dep modules
  ],
  declarations: [ 
    TextShortenerPipe,
    FileSizeConverterPipe,
    ignoreHtmlSanifications
  ],
  exports: [
    TextShortenerPipe,
    FileSizeConverterPipe,
    ignoreHtmlSanifications
  ]
})
export class ApplicationPipesModule {}